import Vue from "vue";
import EventBus from "./eventBus";
Vue.prototype.$EventBus = EventBus;